
import { useEffect, useState } from 'react';
import { Elements, useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';import { loadStripe } from '@stripe/stripe-js';
import { useMutation } from '@apollo/client';
import { Col, Row } from 'reactstrap';
import '../assets/css/StripeStyles.css'; // Import the external styles
import { SEND_SINGLE_STRIPE_TRANSACTION } from '../graphql/mutations/stripe';

const PaymentForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [formError, setformError] = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState(null);
  const [zipCode, setZipCode] = useState(''); // State for zip code

  //start of custom stuff
  const [loading, setLoading] = useState(false);
  const [theCardToken, setCardToken] = useState();

  // let cardToken;

  const [sendSingleStripeTransaction] = useMutation(SEND_SINGLE_STRIPE_TRANSACTION);

  const SendIFrameMessage = (data, action) => {
    window.parent.postMessage({ type: 'FROM_IFRAME', payload: { data: data, action: action } }, process.env.REACT_APP_WOWCLOUD_PARENT + '/checkout/ed00261a-87f6-4744-8915-e2d4f40b1111'); //Parent
  }

  useEffect(() => {
    const handleIframeMessage = (event) => {
      if (event.origin !== process.env.REACT_APP_WOWCLOUD_PARENT) return; //Parent
  
      const { type, payload } = event.data;
      if (type === 'FROM_PARENT') {
        if(payload.action === "SendBillingData"){
          const serverPayload = {
            token: theCardToken.id,
            paymentdata: {
              firstname: payload.data.firstname,
              lastname: payload.data.lastname,
              address: payload.data.address1,
              address2: payload.data.address2,
              city: payload.data.city,
              state: payload.data.state,
              zip: parseInt(payload.data.zip),
              phone: payload.data.phone,
              email: payload.data.email,
              country: "US",
              price: parseInt(payload.data.price),
              expMonth: parseInt(theCardToken.card.exp_month),
              expYear: parseInt(theCardToken.card.exp_year),
              lastFour: parseInt(theCardToken.card.last4),
              processorTransactionId: theCardToken.id,
              bin: "",
              paymentid: payload.data.paymentid,
              productid: payload.data.productid,
              refid: payload.data.refid,
              shortdescription: payload.data.shortdescription,
              existingcustomer: payload.data.existingcustomer,
              referral: payload.data.referral,
            }
          }

          SendSingleTransaction(serverPayload)
        }
        else if(payload.action == "Reset"){
          setLoading(false);
        }
      }
    };
  
    window.addEventListener('message', handleIframeMessage);
  
    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, [theCardToken]);

  const SendSingleTransaction = (serverPayload) => {
    sendSingleStripeTransaction({ variables: {token: serverPayload.token, paymentdata: serverPayload.paymentdata}})
    .then((tres) => {
      if(tres.data.sendSingleStripeTransaction.status){
        SendIFrameMessage(tres.data.sendSingleStripeTransaction.data, "TransactionSuccess")
        // setLoading(false);
      }
      else{
        if(tres.data.sendSingleStripeTransaction.error === "CardValidationRequired"){
          SendIFrameMessage(tres.data.sendSingleStripeTransaction.error, "CardValidationRequired")
          setLoading(false);
        }
        else{
          SendIFrameMessage(tres.data.sendSingleStripeTransaction.error, "TransactionError")
          setLoading(false);
        }
      }
    })
    .catch((err) => {
      // console.log("ERROR2", err)
    })
    .finally(() =>{
      //TODO: Set loading
    })
  }
  //end of custom stuff

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements || !zipCode || zipCode === "") {
      setformError("All fields are required")
      // return;
    }
    else{
      const cardNumberElement = elements.getElement(CardNumberElement);

      // Create payment method with card and billing details (zip code)
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardNumberElement,
        billing_details: {
          address: {
            postal_code: zipCode, // Include zip code
          },
        },
      });

      if (error) {
        setformError(error.message)
        console.log("error", error)
      } else {
        setCardToken(paymentMethod)
        setLoading(true)
        setTimeout(() => {
          SendIFrameMessage(null, "SendBillingData");
        }, 1000)
        handleReset();
        // Send paymentMethod.id to your backend to process the payment
      }

      // Clear the form fields on success
      setLoading(false);
    }
  };

  const handleReset = () => {
    // Clear all the Stripe elements
    const cardNumberElement = elements.getElement(CardNumberElement);
    const cardExpiryElement = elements.getElement(CardExpiryElement);
    const cardCvcElement = elements.getElement(CardCvcElement);

    if (cardNumberElement) cardNumberElement.clear();
    if (cardExpiryElement) cardExpiryElement.clear();
    if (cardCvcElement) cardCvcElement.clear();

    // Reset zip code state
    setZipCode('');
  };

  const validateWholeNumber = (value) => {
    const wholeNumberRegex = /^\d*$/; // Regular expression to match whole numbers
    return wholeNumberRegex.test(value)
  };

  return (
    <div className="mwContainer">
      {loading &&
        <Row>
          <Col md = "12">
            <h1>Processing ...</h1>
          </Col>
        </Row>
      } 
        
      {!loading &&
      <div className="StripeForm">
        <form onSubmit={handleSubmit}>
          {/* First Line: Card Number */}
          <label>
            Card Number
            <CardNumberElement className="StripeElement" />
          </label>

          {/* Second Line: Expiration Date, CVC, and Zip Code */}
          <div className="second-line">
            <div className="third-width">
              <label>
                Exp Date
                <CardExpiryElement className="StripeElement" />
              </label>
            </div>
            <div className="third-width">
              <label>
                CVC
                <CardCvcElement className="StripeElement" />
              </label>
            </div>
            <div className="third-width">
              <label>
                Zip Code
                <input
                  type="text"
                  className="StripeElement"
                  maxLength={5}
                  value={zipCode}
                  onChange={(event) => {
                    if(validateWholeNumber(event.target.value))
                      setZipCode(event.target.value)
                    else return false
                  }}
                />
              </label>
            </div>
          </div>

          <button type="submit" disabled={!stripe}>
            Pay
          </button>
        </form>
        {formError && <p style={{ color: 'red' }}>{formError}</p> }
        {/* {paymentError && <p style={{ color: 'red' }}>{paymentError}</p>}
        {paymentSuccess && <p style={{ color: 'green' }}>{paymentSuccess}</p>} */}
      </div>
      }
    </div>
  );
};

function StripePayment() {
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHER_KEY);
    return (
      <div className="mwContainer">


        {/* {!loading && */}
          <Elements stripe={stripePromise}>
            <PaymentForm />
          </Elements>
        {/* }  */}
      </div>
  )
}

export default StripePayment;